import { yupResolver } from '@hookform/resolvers'
import FloatButton from '@ifca-root/react-component/src/components/Button/FloatButton'
import EmptyList from '@ifca-root/react-component/src/components/CardList/EmptyList'
import { CommonDialog } from '@ifca-root/react-component/src/components/Dialog/CommonDialog'
import DynamicSubHeader from '@ifca-root/react-component/src/components/Header/DynamicSubHeader'
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  IconButton,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  Menu,
  MenuItem,
  TextField,
} from '@material-ui/core'
import { MoreVert } from '@material-ui/icons'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import { Autocomplete } from '@material-ui/lab'
import { ErrorDialog } from 'components/Dialog/ErrorDialog'
import { ExitConfirmationDialog } from 'components/Dialog/ExitConfirmationDialog'
import SnackBarContext from 'containers/App/Store/SnackBarContext'
import {
  GetCompanyLetterTemplateDocument,
  useCreateCompanyLetterTemplateMutation,
  useDeleteCompanyLetterTemplateMutation,
  useGetCompanyLetterTemplateQuery,
  useGetCompanySummaryQuery,
  useGetLetterTemplateQuery,
  useGetStandardLetterQuery,
  useUpdateCompanyLetterTemplateMutation,
} from 'generated/graphql'
import { handleExitConfirmation } from 'helpers/Form/ExitConfirmation'
import { CommonYupValidation } from 'helpers/Form/YupValidation'
import { useMenuOption } from 'helpers/Hooks/useMenuOption'
import { SystemMsgs } from 'helpers/Messages/SystemMsg'
import React, { useContext, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { useHistory, useParams } from 'react-router'
import { getProductName } from 'utils/logoConfig'
import * as yup from 'yup'

export interface CompanyLetterTemplateProps {
  Name: string
  IsDefault: boolean
  LetterTemplateID: string
  IsWatermark: boolean
  WatermarkText: string
}

export const CompanyLetterTemplateListing = (props: any) => {
  const { pageMode, StandardLetterID, CompanyID }: any = useParams()
  let history = useHistory()
  const {
    anchorEl,
    menu,
    handleClick,
    handleClose,
    resetMenu,
  } = useMenuOption()
  const user = JSON.parse(localStorage.getItem('loggedInUser'))
  const isHomeDefault = localStorage.getItem('isDefault')
  const [deleteLT, setDeleteLT] = useState(false)
  const [open, setOpen] = useState<boolean>(false)
  const [openExitConf, setOpenExitConf] = useState<boolean>(false)
  const [formMode, setFormMode] = useState('')
  const [headerTitle, setHeaderTitle] = useState<string>('')
  const [errMessage, setErrMessage] = useState(null)
  const [errDialog, setErrDialog] = useState(false)
  const productName = getProductName()

  const CompanyLetterTemplateFormSchema = yup.object().shape({
    Name: CommonYupValidation.requireField(SystemMsgs.name()),
    LetterTemplateID: CommonYupValidation.requireField(
      'Letter Template is required'
    ),
    WatermarkText: yup.string().when('IsWatermark', {
      is: true,
      then: schema => schema.required('Watermark Text is required').nullable(),
      otherwise: schema => schema.nullable().notRequired(),
    }),
  })

  const { setOpenSnackBar, setSnackBarMsg }: any = useContext(
    SnackBarContext as any
  )

  const {
    register,
    handleSubmit,
    errors,
    control,
    setValue,
    watch,
    reset,
    formState: { isDirty },
  } = useForm<CompanyLetterTemplateProps>({
    defaultValues: {},
    shouldUnregister: false, // unmount input state will be remained
    resolver: yupResolver(CompanyLetterTemplateFormSchema),
  })

  const {
    loading: getCompanyloading,
    data: { getCompany: curCompany } = { getCompany: [] },
  } = useGetCompanySummaryQuery({
    fetchPolicy: 'network-only',
    variables: { CompanyID },
    onCompleted: () => {
      if (pageMode === 'general-ledger') {
        setHeaderTitle('General Ledger')
      } else if (pageMode === 'cash-book') {
        setHeaderTitle('Cash Book')
      } else if (pageMode === 'account-receivable') {
        setHeaderTitle('Account Receivable')
      } else if (pageMode === 'account-payable') {
        setHeaderTitle('Account Payable')
      } else if (pageMode === 'inventory-control') {
        setHeaderTitle('Inventory Control')
      } else if (pageMode === 'general-purchase') {
        setHeaderTitle('General Purchase')
      }
    },
  })

  const {
    loading: standardLetterloading,
    data: { getStandardLetter } = { getStandardLetter: [] },
  } = useGetStandardLetterQuery({
    fetchPolicy: 'network-only',
    variables: { StandardLetterID },
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
  })

  const {
    loading: getLetterTemplateloading,
    data: { getLetterTemplate } = {
      getLetterTemplate: [],
    },
  } = useGetLetterTemplateQuery({
    fetchPolicy: 'network-only',
    variables: { StandardLetterID },
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
  })

  const {
    loading: getCompanyLetterTemplateloading,
    data: { getCompanyLetterTemplate } = {
      getCompanyLetterTemplate: [],
    },
  } = useGetCompanyLetterTemplateQuery({
    fetchPolicy: 'network-only',
    variables: { StandardLetterID, CompanyID },
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
  })

  const [
    createCompanyLetterTemplate,
    { loading: createCompanyLetterTemplateLoading },
  ] = useCreateCompanyLetterTemplateMutation({
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
    onCompleted: ({ createCompanyLetterTemplate }) => {
      setOpenSnackBar(true)
      setSnackBarMsg(SystemMsgs.createNewRecord())
      if (createCompanyLetterTemplate) {
        setSnackBarMsg('Created Successfully!')
        setOpen(false)
      } else {
        setSnackBarMsg('Create Failed!')
      }
    },
  })

  const [
    //updateCompanyLetterTemplate to updateCompanyLetterTemplate
    updateCompanyLetterTemplate,
    { loading: updateCompanyLetterTemplateLoading },
  ] = useUpdateCompanyLetterTemplateMutation({
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
    onCompleted: ({ updateCompanyLetterTemplate }) => {
      if (updateCompanyLetterTemplate) {
        setOpenSnackBar(true)
        setSnackBarMsg(SystemMsgs.updateRecord())
        setOpen(false)
      } else {
        setSnackBarMsg('Update Failed!')
      }
    },
  })

  const [
    //deleteCompanyLetterTemplate to deleteCompanyLetterTemplate
    deleteCompanyLetterTemplate,
    { loading: deleteCompanyLetterTemplateLoading },
  ] = useDeleteCompanyLetterTemplateMutation({
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
    onCompleted: ({ deleteCompanyLetterTemplate }) => {
      setOpenSnackBar(true)
      setSnackBarMsg(SystemMsgs.deleteRecord())
      setDeleteLT(false)
      if (deleteCompanyLetterTemplate) {
        setSnackBarMsg('Deleted Successfully!')
        setDeleteLT(false)
      } else {
        setSnackBarMsg('Delete Failed!')
      }
    },
  })

  const onSubmit = (data, menu) => {
    if (formMode === 'edit') {
      updateCompanyLetterTemplate({
        variables: {
          input: {
            CompanyLetterTemplateID: menu?.obj?.CompanyLetterTemplateID,
            Name: data?.Name,
            StandardLetterID,
            CompanyID,
            IsDefault: data?.IsDefault,
            LetterTemplateID: data?.LetterTemplateID,
            IsWatermark: data?.IsWatermark,
            WatermarkText: data?.WatermarkText,
          },
        },
        refetchQueries: [
          {
            query: GetCompanyLetterTemplateDocument,
            variables: { StandardLetterID, CompanyID },
          },
        ],
      })
    } else if (formMode === 'add') {
      createCompanyLetterTemplate({
        variables: {
          input: {
            Name: data?.Name,
            StandardLetterID,
            CompanyID,
            IsDefault: data?.IsDefault,
            LetterTemplateID: data?.LetterTemplateID,
            IsWatermark: data?.IsWatermark,
            WatermarkText: data?.WatermarkText,
          },
        },
        refetchQueries: [
          {
            query: GetCompanyLetterTemplateDocument,
            variables: { StandardLetterID, CompanyID },
          },
        ],
      })
    }
  }

  const handleDelete = data => {
    deleteCompanyLetterTemplate({
      variables: {
        input: { CompanyLetterTemplateID: data?.CompanyLetterTemplateID },
      },
      refetchQueries: [
        {
          query: GetCompanyLetterTemplateDocument,
          variables: { StandardLetterID, CompanyID },
        },
      ],
    })
    setDeleteLT(false)
  }

  const checkSameName = () => {
    const getLT = !menu?.obj
      ? getCompanyLetterTemplate
      : getCompanyLetterTemplate?.filter(
          x => x?.CompanyLetterTemplateID !== menu?.obj?.CompanyLetterTemplateID
        )

    const sameName = getLT?.filter(
      el => el?.Name.toLocaleLowerCase() === watch('Name')?.toLocaleLowerCase()
    )

    if (sameName?.length > 0) {
      return true
    } else return false
  }

  const hasChanges = () =>
    handleExitConfirmation({
      watch: watch,
      editData: menu?.obj,
      formMode: formMode,
    })

  return (
    <>
      {getCompanyloading && <Loading />}
      {standardLetterloading && <Loading />}
      {getLetterTemplateloading && <Loading />}
      {getCompanyLetterTemplateloading && <Loading />}
      {createCompanyLetterTemplateLoading && <Loading />}
      {updateCompanyLetterTemplateLoading && <Loading />}
      {deleteCompanyLetterTemplateLoading && <Loading />}
      <MainHeader
        mainBtn="back"
        onClick={() => {
          history.push({
            pathname: `/${pageMode}/${CompanyID}/company-setting/company-standard-letter`,
          })
        }}
        smTitle={isHomeDefault === 'true' ? productName : headerTitle}
        title={curCompany[0]?.Name}
        routeSegments={[
          { name: 'System Admin' },
          { name: 'Document Template' },
          { name: 'Company Letter Template', current: true },
        ]}
      />
      <DynamicSubHeader
        title={curCompany[0]?.Name}
        infoLine={getStandardLetter[0]?.Name}
      />
      <ContentWrapper multiDynamicInfo>
        {getCompanyLetterTemplate?.length === 0 ? (
          <EmptyList
            title="No Company Letter Template"
            subtitle="Please create new Company Letter Template"
          />
        ) : (
          <List className="core-list">
            {getCompanyLetterTemplate?.map((v, index) => (
              <ListItem>
                <ListItemText
                  primary={
                    <div className="xsTitle">
                      <span>{v?.Name}</span>
                      {v?.IsDefault === true ? (
                        <span>
                          <CheckCircleIcon
                            style={{ color: 'limegreen', fontSize: 'medium' }}
                          />
                        </span>
                      ) : null}
                    </div>
                  }
                  secondary={
                    <span className="desc">{v?.IsReportDesignEditor}</span>
                  }
                />
                <ListItemSecondaryAction>
                  <IconButton
                    edge="end"
                    aria-label="delete"
                    aria-controls="menu-list"
                    aria-haspopup="true"
                    onClick={e =>
                      handleClick(e, v?.CompanyLetterTemplateID, index, v)
                    }
                  >
                    <MoreVert />
                  </IconButton>
                </ListItemSecondaryAction>
              </ListItem>
            ))}
          </List>
        )}
      </ContentWrapper>
      <CommonDialog
        fullWidth={true}
        open={open}
        onClose={() => {
          if (hasChanges() === true) {
            setOpenExitConf(true)
          } else {
            setOpen(false)
            reset()
            resetMenu()
          }
        }}
        sections={{
          header: {
            title: 'Company Letter Template',
            rightText: formMode === 'edit' ? 'Edit' : 'New',
          },
          body: () => (
            <>
              <div className="content-container">
                <Controller
                  as={TextField}
                  id="standard-basic"
                  name="Name"
                  label={'Name'}
                  required
                  control={control}
                  fullWidth
                  helperText={
                    checkSameName() === true
                      ? 'Name already exsist.'
                      : errors?.Name
                      ? errors?.Name.message
                      : null
                  }
                  error={
                    checkSameName() === true || errors?.Name ? true : false
                  }
                  ref={register}
                />

                <Controller
                  render={({ value, onChange }) => {
                    const defVal = getLetterTemplate?.filter(
                      x => x?.LetterTemplateID === menu?.obj?.LetterTemplateID
                    )[0]
                    return (
                      <Autocomplete
                        options={
                          getLetterTemplate?.sort((a, b) => {
                            return a?.Name?.localeCompare(b?.Name)
                          }) || []
                        }
                        getOptionLabel={option => `${option?.Name}`}
                        fullWidth
                        onChange={(value, newValue: any) => {
                          setValue(
                            'LetterTemplateID',
                            newValue?.LetterTemplateID
                          )
                        }}
                        renderOption={(props, option) => {
                          return <span>{props?.Name}</span>
                        }}
                        defaultValue={defVal}
                        renderInput={(params: any) => {
                          return (
                            <div>
                              <TextField
                                {...params}
                                helperText={errors?.LetterTemplateID?.message}
                                error={errors?.LetterTemplateID ? true : false}
                                label="Letter Template"
                                style={{ width: '100%' }}
                                margin="dense"
                                required
                              />
                            </div>
                          )
                        }}
                      />
                    )
                  }}
                  label="Letter Template"
                  name="LetterTemplateID"
                  autoComplete="off"
                  control={control}
                  multiline={true}
                  fullWidth
                  margin="dense"
                  ref={register}
                  helperText={errors?.LetterTemplateID?.message}
                  error={errors?.LetterTemplateID ? true : false}
                  defaultValue={menu?.obj?.LetterTemplateID}
                  required
                />
                {/* <FormControl component="fieldset">
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={watch('JointBuyerSignRequired')}
                        onChange={e =>
                          setValue('JointBuyerSignRequired', e.target.checked)
                        }
                        name="JointBuyerSignRequired"
                        color="primary"
                        defaultValue={menu?.obj?.JointBuyerSignRequired}
                      />
                    }
                    label="Joint Buyer Signature"
                  />
                </FormControl>

                <FormControl component="fieldset">
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={watch('IsReportDesignEditor')}
                        onChange={e =>
                          setValue('IsReportDesignEditor', e.target.checked)
                        }
                        name="IsReportDesignEditor"
                        color="primary"
                        defaultValue={menu?.obj?.IsReportDesignEditor}
                      />
                    }
                    label="Only allow in Html editor"
                  />
                </FormControl> */}
                <FormControl component="fieldset">
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={watch('IsDefault')}
                        onChange={e => setValue('IsDefault', e.target.checked)}
                        name="IsDefault"
                        color="primary"
                        defaultValue={menu?.obj?.IsDefault}
                      />
                    }
                    label="Default"
                  />
                </FormControl>

                <FormControl component="fieldset">
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={watch('IsWatermark')}
                        onChange={e =>
                          setValue('IsWatermark', e.target.checked)
                        }
                        name="IsWatermark"
                        color="primary"
                        defaultValue={menu?.obj?.IsWatermark}
                      />
                    }
                    label="Watermark"
                  />
                </FormControl>

                {watch('IsWatermark') && (
                  <Controller
                    as={TextField}
                    id="standard-basic"
                    name="WatermarkText"
                    label={'Watermark Text'}
                    control={control}
                    fullWidth
                    required
                    helperText={
                      errors?.WatermarkText
                        ? errors?.WatermarkText.message
                        : null
                    }
                    error={errors?.WatermarkText ? true : false}
                    defaultValue={menu?.obj?.WatermarkText ?? 'DRAFT'}
                    ref={register}
                  />
                )}
              </div>
            </>
          ),
          footer: {
            actions: [
              {
                displayText: 'Cancel',
                props: {
                  onClick: () => {
                    if (hasChanges() === true) {
                      setOpenExitConf(true)
                    } else {
                      setOpen(false)
                      reset()
                      resetMenu()
                    }
                  },
                  variant: 'contained',
                  color: 'primary',
                },
              },
              {
                displayText: 'Confirm',
                props: {
                  onClick: () => handleSubmit(data => onSubmit(data, menu))(),
                  variant: 'contained',
                  color: 'primary',
                  disabled: checkSameName(),
                },
              },
            ],
          },
        }}
      />
      <FloatButton
        onClick={() => {
          setValue('Name', '')
          // setValue('JointBuyerSignRequired', false)
          // setValue('IsReportDesignEditor', false)
          setValue('IsDefault', false)
          setValue('LetterTemplateID', '')
          setOpen(true)
          setFormMode('add')
          resetMenu()
        }}
      />
      <Menu
        id="menu-list"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        onClick={handleClose}
      >
        <MenuItem
          // disabled={handlePermDisabled({
          //   companyID: CompanyID,
          //   permEnum: AcctPermission.AccPayableBatchPaymentUpdate,
          // })}
          onClick={() => {
            history.push({
              pathname: `/${pageMode}/${CompanyID}/company-setting/company-standard-letter/${StandardLetterID}/company-letter-template/${menu?.obj?.CompanyLetterTemplateID}/design`,
              state: menu?.obj,
            })
          }}
        >
          Design
        </MenuItem>
        <MenuItem
          // disabled={handlePermDisabled({
          //   companyID: CompanyID,
          //   permEnum: AcctPermission.AccPayableBatchPaymentDelete,
          // })}
          onClick={() => {
            setValue('Name', menu?.obj?.Name)
            // setValue(
            //   'JointBuyerSignRequired',
            //   menu?.obj?.JointBuyerSignRequired
            // )
            // setValue('IsReportDesignEditor', menu?.obj?.IsReportDesignEditor)
            setValue('IsDefault', menu?.obj?.IsDefault)
            setValue('LetterTemplateID', menu?.obj?.LetterTemplateID)
            setOpen(true)
            setFormMode('edit')
          }}
        >
          Edit
        </MenuItem>
        <MenuItem
          disabled={menu?.obj?.IsDefault}
          onClick={() => setDeleteLT(true)}
        >
          Delete
        </MenuItem>
      </Menu>
      <CommonDialog
        fullWidth
        open={deleteLT}
        onClose={() => setDeleteLT(false)}
        sections={{
          header: {
            title: 'Company Letter Template',
            rightText: `Delete`,
          },
          body: () => (
            <div className="content-wrap full">
              <span
                style={{
                  fontSize: '12px',
                  lineHeight: '14px',
                  fontWeight: 500,
                }}
              >
                {`Are you sure you want to delete ${menu?.obj?.Name}?`}
              </span>
            </div>
          ),
          footer: {
            actions: [
              {
                displayText: 'Cancel',
                props: {
                  onClick: () => setDeleteLT(false),
                  variant: 'contained',
                  color: 'primary',
                },
              },
              {
                displayText: 'Confirm',
                props: {
                  onClick: () => {
                    handleDelete(menu?.obj)
                  },
                  variant: 'contained',
                  color: 'primary',
                },
              },
            ],
          },
        }}
      />
      <ExitConfirmationDialog
        openExitConf={openExitConf}
        setOpenExitConf={setOpenExitConf}
        onConfirm={() => {
          setOpen(false)
          setOpenExitConf(false)
          reset()
        }}
      />
      <ErrorDialog
        errorDia={errDialog}
        setErrorDia={setErrDialog}
        errorMsg={errMessage}
        errorHeaderMsg={'Error!'}
      />
    </>
  )
}
